module.exports = __webpack_public_path__ + "static/media/dodgem(13).ba0eba66.PNG";